import { gate } from 'hub-http/gates';
export const CRM_SEARCH_FILTERS_V2_UEQL_REPORTS = gate('ReportingEnablement:FiltersV2:UAQLReports');
export const EXTENSIBLE_REPORT_FILTERS_BAR = gate('ReportingEnablement:FiltersV2:ExtensibleReports');
export const PREFER_IS_EXTERNAL_OPTIONS_PROPERTY = gate('ReportingEnablement:PreferIsExternalOptionsProperty');
export const CUSTOM_WIDGET_FILTERS_V2 = gate('ReportingEnablement:FiltersV2:CustomWidgets');
export const CRM_DEAL_LIST_CREATION = 'CRM:Segments:DealListsCreation';
export const USE_REPORT_CONFIG_TO_CREATE_LIST = 'Reporting:UseReportConfigToCreateList';
export const SNOWFLAKE_PROPERTY_FILTER_GATE = gate('ReportCreation:SnowflakePropertyFilterMigration');